import React from 'react';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

import { AnswerValues } from './PublicSurveyContainer';

interface PublicTextQuestionProps {
  value?: string;
  onChange: (value: AnswerValues) => void;
  currentLanguage: string;
}

export const PublicTextQuestion: React.FC<PublicTextQuestionProps> = ({
  value,
  onChange,
  currentLanguage,
}) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  const maxLength = 1800;
  const currentLength = value?.length || 0;

  return (
    <div>
      <textarea
        value={value || ''}
        onChange={e => onChange({ textValue: e.target.value })}
        placeholder={t(tk.publicSurvey.enterYourAnswer)}
        className="public-survey-textarea"
        maxLength={maxLength}
      />
      <div className="text-muted small text-end mt-1">
        {currentLength} / {maxLength}
      </div>
    </div>
  );
};
